import { PaymentStatusEnum, VerticalSignalingEnum } from "src/enumerators/vertical-signaling.enum";
import { IRest } from "./rest.interface";
import { Address } from "./signaling";
import { Member } from "./user";
import { PendingStatusEnum } from "src/enumerators";
import { Contract } from "./contract";
import { ServiceTypeEnum } from "src/enumerators/service.enum";

export class TypeService implements IRest {
  className: 'Tipo de Serviços';

  id: string;
  contractServiceItemId: string;
  serviceId: string;
  createdAt: string;
  updatedAt: string;
  serviceType: ServiceTypeEnum;
  quantity: number;

  constructor(data?: any) {
    if (data) this.Deserialize(data);
  };

  Serialize() {
    const out = {
      id: this.id,
      contractServiceItemId: this.contractServiceItemId,
      serviceId: this.serviceId,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      serviceType: this.serviceType,
      quantity: this.quantity,
    }

    return out;
  }

  Deserialize(data: any) {
    if (data) {
      this.id = data['id'] || undefined;
      this.contractServiceItemId = data['contractServiceItemId'] || undefined;
      this.serviceId = data['serviceId'] || undefined;
      this.createdAt = data['createdAt'] || undefined;
      this.updatedAt = data['updatedAt'] || undefined;
      this.serviceType = data['serviceType'] || undefined;
      this.quantity = data['quantity'] || 1;
    }
  }
}

export class ServiceModel implements IRest {
  className = 'Serviços';

  id: string;
  contractId: string;
  workspaceId: string;
  memberId: string;
  address: Address
  latitude: number;
  longitude: number;
  status: PendingStatusEnum;
  verticalCode: VerticalSignalingEnum;
  observations: string;
  createdAt: Date;
  updatedAt: Date;
  types: TypeService[];
  incorrectLocation: boolean;
  paymentStatus: PaymentStatusEnum;
  files: any[];

  responsibleMember: Member;
  contract: Contract;
  serviceTypesNames: string;
  check: boolean;

  constructor(data?: any) {
    if (data) this.Deserialize(data);
  };

  Serialize() {
    const out = {
      id: this.id,
      contractId: this.contractId,
      workspaceId: this.workspaceId,
      memberId: this.memberId,
      address: this.address,
      latitude: this.latitude,
      longitude: this.longitude,
      status: this.status,
      verticalCode: this.verticalCode,
      observations: this.observations,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      types: this.types,
      incorrectLocation: this.incorrectLocation,
      paymentStatus: this.paymentStatus,
      files: this.files,

    };

    return out;
  };

  Deserialize(data: any) {
    if (data) {
      this.id = data['id'] || undefined;
      this.contractId = data['contractId'] || undefined;
      this.workspaceId = data['workspaceId'] || undefined;
      this.memberId = data['memberId'] || undefined;
      this.address = new Address(data['address'] || {});
      this.latitude = parseFloat(data['latitude']) || undefined;
      this.longitude = parseFloat(data['longitude']) || undefined;
      this.status = data['status'] || PendingStatusEnum.Pending;
      this.verticalCode = data['verticalCode'] || undefined;
      this.observations = data['observations'] || undefined;
      this.createdAt = data['createdAt'] || undefined;
      this.updatedAt = data['updatedAt'] || undefined;
      this.incorrectLocation = data['incorrectLocation'] || false;
      this.paymentStatus = data['paymentStatus'] || PaymentStatusEnum.Pending;
      this.types = (data['types'] || []).map((t) => new TypeService(t));
      this.files = data['files'] || [];
    };

    return this;
  };
}
